/**
 * An object containing all of the publications.
 */
export const PROPERTIES = Object.freeze({
  BARRONS: 'barrons',
  FN_LONDON: 'fnlondon',
  MANSION_GLOBAL: 'mansionglobal',
  MARKET_WATCH: 'marketwatch',
  WSJ: 'wsj',
  DJ_RISKJOURNAL: 'djriskjournal',
});

/**
 * An object containing the text value of the recessions annotation for a variety of cases. Cases
 * include different languages and publications.
 */
export const RECESSION_LABEL_TEXT = Object.freeze({
  BARRONS: 'Recessions are shaded',
  CH: '衰退期',
  EN: 'RECESSION',
  JA: '景気後退',
});

/**
 * An object containing different language abbreviations.
 */
export const LANGUAGES = Object.freeze({
  CHINESE: 'ch',
  ENGLISH: 'en',
  JAPANESE: 'ja',
});

/**
 * An object containing supported media types.
 */
export const MEDIA_TYPES = Object.freeze({
  VIDEO: 'VIDEO',
  DIGITAL_WSJ: 'DIGITAL_WSJ',
  DIGITAL_BARRONS: 'DIGITAL_BARRONS',
});

/**
 * An object containing information related to the position of the annotation for the plot bands.
 */
export const ANNOTATION_POSITION = Object.freeze({
  BOTTOM: {
    KEY: 'BOTTOM',
    LABEL: 'Below top line',
    VALUE: {
      VIDEO: 33,
      DIGITAL_WSJ: 12,
      DIGITAL_BARRONS: 14,
    },
  },
  TOP: {
    KEY: 'TOP',
    LABEL: 'Above top line',
    VALUE: {
      VIDEO: -12,
      DIGITAL_WSJ: -3,
      DIGITAL_BARRONS: -5,
    },
  },
});

/**
 * An object containing information about the plot band group form fields.
 */
export const GROUP_PROPERTIES = Object.freeze({
  ANNOTATION: {
    KEY: 'annotation',
    LABEL: 'Annotation',
  },
  ANNOTATION_INDEX: {
    KEY: 'annotationIndex',
    LABEL: 'Annotation Location',
  },
  ANNOTATION_POSITION: {
    KEY: 'annotationPosition',
    LABEL: 'Label Position',
  },
  COLOR: {
    KEY: 'color',
    LABEL: 'Band Color',
  },
  PLOT_BANDS: {
    LABEL: 'Plot Bands',
    KEY: 'plotBands',
  },
});
